import { useEffect, useRef, useState } from "react";
import type { Trabajo } from "../api";

const MARCA: Record<string, string> = { hecho: "✓", en_curso: "●", pendiente: "○", fallido: "✕", interrumpido: "‖" };
const DICHO: Record<string, string> = { hecho: "hecho", en_curso: "en curso", pendiente: "pendiente", fallido: "falló aquí", interrumpido: "se cortó aquí" };

/**
 * Los pasos de un trabajo largo, uno a uno (Rais, 23-sep: «los 29 pasos de la corrección, cuáles se
 * van completando, no solo la barra de arriba»). Con un motor que no manda pasos no pinta nada: la
 * línea «parte N de M» de siempre sigue diciendo lo mismo.
 */
export function ListaDePasos({ trabajo }: { trabajo: Trabajo | null | undefined }) {
  const pasos = trabajo?.pasos ?? null;
  const vivo = trabajo?.estado === "en_curso";
  const [abierta, setAbierta] = useState(vivo);
  const actual = useRef<HTMLLIElement>(null);
  useEffect(() => { if (vivo) setAbierta(true); }, [vivo]);
  // El paso en curso se queda a la vista dentro de la lista, sin mover la página.
  useEffect(() => {
    const li = actual.current, ol = li?.parentElement;
    if (li && ol) ol.scrollTop = Math.max(0, li.offsetTop - ol.offsetTop - ol.clientHeight / 2);
  }, [pasos?.findIndex((p) => p.estado === "en_curso")]);
  if (!pasos?.length) return null;
  const hechos = pasos.filter((p) => p.estado === "hecho").length;
  return (
    <div className="lista-pasos">
      <button className="btn texto" aria-expanded={abierta} onClick={() => setAbierta(!abierta)}>
        {abierta ? "Ocultar los pasos" : "Ver los pasos"} · {hechos} de {pasos.length} hechos
      </button>
      {abierta && (
        <ol>
          {pasos.map((p, i) => (
            <li key={i} className={p.estado} ref={p.estado === "en_curso" ? actual : undefined} title={DICHO[p.estado]}>
              <span className="marca" aria-hidden="true">{MARCA[p.estado] ?? "○"}</span>
              <span className="num">{i + 1}</span>
              <span className="tit">{p.titulo}</span>
              <span className="sr">{DICHO[p.estado]}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
